import querystring from 'query-string';
import BaseService from './BaseService';

class ProfileService extends BaseService {
  fetchProfile = (characterName, fromEchoId) => {
    let url = `/profile?characterName=${characterName}`;
    if (fromEchoId) {
      url += `/${fromEchoId}`;
    }

    const config = {
      url,
    };
    return this.doRequest(config);
  };

  deleteEntry = (entryId) => {
    const config = {
      method: 'post',
      url: '/profile/delete',
      data: {entryId}
    };
    return this.doRequest(config);
  };

  fetchSharedContent = ({
    characterName,
    date,
    fromId,
    offset,
    count,
    ...rest
  }) => {
    const qs = querystring.stringify({
      characterName,
      date,
      fromId,
      offset,
      count,
      ...rest,
    });
    const config = {
      method: 'get',
      url: `/profile/shares?${qs}`,
    };
    return this.doRequest(config);
  };

  fetchSharedContentByUrl = (url) => {
    const config = { url };
    return this.doRequest(config);
  };

  updateDescription = (newDescription) => {
    const config = {
      method: 'post',
      url: '/profile/update',
      data: { newDescription },
    };
    return this.doRequest(config);
  };

  share = (contentClass, contentKey, image, message) => {
    const config = {
      method: 'post',
      url: '/profile/share',
      data: {
        contentClass,
        image,
        message,
        contentKey,
      },
    };
    return this.doRequest(config);
  };
}

export { ProfileService as default };